/** Local translation helper — graduate app has no react-i18next. */
export function t(key, fallback, interpolation) {
  if (fallback && typeof fallback === 'object' && !Array.isArray(fallback)) {
    interpolation = fallback;
    fallback = fallback.defaultValue;
  }
  let text = typeof fallback === 'string' && fallback ? fallback : String(key || '');
  if (interpolation && typeof interpolation === 'object') {
    Object.entries(interpolation).forEach(([name, value]) => {
      if (name === 'defaultValue') return;
      text = text.replace(new RegExp(`{{\\s*${name}\\s*}}`, 'g'), String(value ?? ''));
    });
  }
  return text;
}

export function useTranslation() {
  return { t, i18n: { language: 'en' } };
}
